<template>
    <div class="registered-meeting-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Add Registered Meeting</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <loading-screen-svg v-if="isLoading" />
                <div v-else>
                    <div class="input-container agency">
                        <label>Agency</label>
                        <agency-search
                            v-model="registeredMeeting.agency"
                            :clientId="clientId" />
                        <div class="red-accent error-message" v-if="$v.registeredMeeting.agency.$error">You must select an agency</div>
                        <div class="red-accent error-message" v-show="agencyExists">This agency has already been selected</div>
                    </div>
                </div>
            </div>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="save()">Save</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AgencySearch = () => import('@/components/agency/agency-search');
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import { required } from 'vuelidate/lib/validators';
import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'registered-meeting-widget',

    props: {
        widget: {
            type: Object   
        }
    },

    components: {
        'agency-search': AgencySearch,
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg
    },

    data() {
        return {
            isLoading: false,

            clientId: this.widget.clientId,

            registeredMeeting: {
                id: this.widget.registeredMeetingId,
                meetingActivityId: this.widget.activityId,
                agency: null
            },

            existingAgencyIds: []
        }
    },

    validations: {
        registeredMeeting: {
            agency: {
                required
            }
        }
    },

    computed: {
        agencyExists() {
            return this.registeredMeeting.agency && this.existingAgencyIds.some(id => id === this.registeredMeeting.agency.id);
        },
        
        isValid() {
            this.$v.$touch();

            return this.$v.$invalid || this.agencyExists;
        }
    },

    methods: {
        save() {
            if (this.isValid) {
                return;
            }

            this.isLoading = true;

            this.post();
        },

        post() {
            var registeredMeeting = {
                MeetingActivityId: this.registeredMeeting.meetingActivityId,
                AgencyId: this.registeredMeeting.agency.id,
            }

            this.$api
                .post(`/api/RegisteredMeetings`, registeredMeeting)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your registered meeting has been successfully created.');
                    EventBus.$emit('registered-meeting:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while creating your registered meeting.', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getExistingRegisteredMeetings() {
            this.isLoading = true;

            var restUrl = `/service/MeetingActivities?$filter=Id eq ${ this.registeredMeeting.meetingActivityId }&$expand=RegisteredMeetings($select=AgencyId)&$select=Id,RegisteredMeetings`;

            this.$api
                .get(restUrl)
                .then(response => {
                    this.existingAgencyIds = response.data.value[0].RegisteredMeetings.map(registeredMeeting => registeredMeeting.AgencyId);
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('Failed to get meeting activities.', { error })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        }
    },

    created() {
        this.getExistingRegisteredMeetings();
    }
}
</script>

<style>
.registered-meeting-widget .input-container {
    margin-bottom: 15px;
}

.registered-meeting-widget .cancel-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.registered-meeting-widget .cancel-btn:hover {
    background: #E1E0E5;
}

.registered-meeting-widget .loading-screen {
    text-align: center;
}

.registered-meeting-widget .error-message {
    margin-top: 8px;
    font-size: 12px;
}
</style>